import { useCallback } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

import { useTkv2UpdateReferenceBarProperties } from '../../../controller/hooks/useTkv2UpdateReferenceBarProperties.ts';
import { useActiveReferenceBarID } from '../../../controller/hooks/useActiveReferenceBarID.ts';
import { formatReferenceViewID } from '../referenceViewID/formatReferenceViewID.ts';
import { ReferenceViewIDParsed } from '../referenceViewID/types.ts';
import { Feature } from './types.ts';

export const useHandlePinClick = () => {
  const activeID = useActiveReferenceBarID();
  const updateRefBarProperties = useTkv2UpdateReferenceBarProperties();
  const { activeID: routeActiveID } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  return useCallback(
    (feature?: Feature) => {
      const clickedID = feature?.properties.id;
      if (!clickedID) return;

      const refViewID: ReferenceViewIDParsed =
        clickedID === 'subject'
          ? {
              type: 'subject',
            }
          : {
              type: 'comparable',
              compID: clickedID,
            };

      const formattedID = formatReferenceViewID(refViewID);
      const shouldToggleToSubject = formattedID === activeID && refViewID.type !== 'subject';
      const nextID = shouldToggleToSubject ? formatReferenceViewID({ type: 'subject' }) : formattedID;

      if (routeActiveID && location.pathname.endsWith(`/${routeActiveID}`)) {
        const parts = location.pathname.split('/');
        parts[parts.length - 1] = nextID;
        navigate(parts.join('/'), { replace: true });
      }

      updateRefBarProperties({
        id: nextID,
        mapPinLabel: shouldToggleToSubject || refViewID.type === 'subject' ? '' : feature?.properties.idx?.toString() ?? '',
      });
    },
    [activeID, location.pathname, navigate, routeActiveID, updateRefBarProperties],
  );
};
